import React from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import ComingPageBG from "@frameworks/shared-library/assets/images/SalesJourney/common/ComingPageBG.png";
var DefaultPage = function () {
    return (React.createElement(GridContainer, { parentClass: " default-page-container" },
        React.createElement("div", { className: "default-page" },
            React.createElement("div", { className: "text-in-page " },
                React.createElement("span", { className: "DMSan_28_700" }, "Coming Soon"),
                React.createElement("span", { className: "DMSansN_24_400" }, "We're Brewing Something Awesome!"),
                React.createElement("span", { className: "txt-tomato DMSansN_24_400 font-bold" }, "Stay Tuned")),
            React.createElement("img", { src: ComingPageBG, alt: "", className: "default-page-bg-image" }))));
};
export default DefaultPage;
